module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 105
// module chunks = 0